import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
  Box,
  useTheme,
  useMediaQuery
} from '@mui/material';

const TableLoadingSkeleton = ({ rows = 9 }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

  const SkeletonRow = () => (
    <TableRow>
      {/* Name column with avatar */}
      <TableCell>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton 
            variant="text" 
            width={isMobile ? 80 : 120} 
            height={24} 
          />
        </Box>
      </TableCell>
      
      {/* Email column */}
      {!isMobile && (
        <TableCell>
          <Skeleton 
            variant="text" 
            width={isTablet ? 150 : 200} 
            height={20} 
          />
        </TableCell>
      )}
      
      {/* Activity column */}
      <TableCell>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Skeleton variant="circular" width={8} height={8} />
          <Skeleton 
            variant="text" 
            width={isMobile ? 60 : 100} 
            height={20} 
          />
        </Box>
      </TableCell>
      
      {/* Time column */}
      {!isMobile && (
        <TableCell>
          <Skeleton 
            variant="text" 
            width={60} 
            height={20} 
          />
        </TableCell>
      )}
      
      {/* Chat With column */}
      {!isTablet && (
        <TableCell>
          <Skeleton 
            variant="text" 
            width={100} 
            height={20} 
          />
        </TableCell>
      )}
      
      {/* Actions column */}
      <TableCell>
        <Skeleton 
          variant="rounded" 
          width={isMobile ? 80 : 120} 
          height={32} 
          sx={{ borderRadius: 1 }}
        />
      </TableCell>
    </TableRow>
  );

  return (
    <TableContainer 
      component={Paper} 
      sx={{ boxShadow: "none", border: "none" }}
    >
      <Table sx={{ minWidth: isMobile ? 300 : 650 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: 'grey.50' }}>
            <TableCell>
              <Skeleton variant="text" width={60} height={20} />
            </TableCell>
            {!isMobile && (
              <TableCell>
                <Skeleton variant="text" width={60} height={20} />
              </TableCell>
            )}
            <TableCell>
              <Skeleton variant="text" width={60} height={20} />
            </TableCell>
            {!isMobile && (
              <TableCell>
                <Skeleton variant="text" width={40} height={20} />
              </TableCell>
            )}
            {!isTablet && (
              <TableCell>
                <Skeleton variant="text" width={80} height={20} />
              </TableCell>
            )}
            <TableCell>
              <Skeleton variant="text" width={60} height={20} />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: rows }, (_, index) => (
            <SkeletonRow key={index} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableLoadingSkeleton;